/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <div class="legend-container">
      <MapLegend
        v-for="leg in legend"
        :key="leg.name"
        class="px-2 py-1"
        :text="$t(leg.name)"
        :shape="leg.attr"
      />
    </div>  
    <div class="container-height">
      <StatusCard :blockList="blockList" :groupedByBlock="groupedByBlock" :healthyValues="healthyValues" :paramNameMap="paramNameMap"/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
import fireAlarmApi from '../services/firealarm'
import { mapGettersMixin } from '@/util/mixin/index'
import StatusCard from '../components/common/StatusCards.vue'
import MapLegend from '../components/common/MapLegend.vue'

export default {
  mixins: [ mapGettersMixin ],
  components: {
    StatusCard,
    MapLegend
  },
  data() {
    return {
      blockList: [],
      fireAlarmData: {},
      healthyValues: {},
      paramNameMap: {},
      legend: [
        {
          name: "On / Healthy / Okay",
          attr: {
            name: "square",
            color: "#3CB371",
          },
        },
        {
          name: "Off / Fault / Not Okay",
          attr: {
            name: "square",
            color: "#FF5252",
          },
        },
        {
          name: "No Communication",
          attr: {
            name: "square",
            color: "#A7A7A7",
          },
        }
      ],
    }
  },
  created() {
    this.initialStates()
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getGeneralState']),
    groupedByBlock() {
      const groupedObject = {}
      Object.keys(this.fireAlarmData).forEach(key => {
        const block = key.split('-')[0]
        if (!groupedObject[block]) {
          groupedObject[block] = {};
        }
        groupedObject[block][key] = this.fireAlarmData[key]
      })

      return groupedObject
    }
  },
  methods: {
    ...mapMutations([ 'SET_PROGRESS_BAR' ]),
    initialStates() {
      this.callAllApi()
    },
    async callAllApi() {
      await this.getBlockList()
      await this.setIntervalWithoutDelay(this.getFireAlarmData)
    },
    async getFireAlarmData() {
      try {
        this.SET_PROGRESS_BAR(true)
        const response = await fireAlarmApi.getFireAlarmData(this.getSelectedPlantId)
        this.fireAlarmData = response.data.data
        this.healthyValues = response.data.config
        this.paramNameMap = response.data.name_map
      } catch (error) {
        this.SET_PROGRESS_BAR(false)
      } finally {
        if(Object.keys(this.groupedByBlock).length > 0) {
          this.SET_PROGRESS_BAR(false) 
        }
      }
    },
    async getBlockList() {
      try {
        this.SET_PROGRESS_BAR(true)
        const response = await fireAlarmApi.getBlockList(this.getSelectedPlantId)
        this.blockList = response.data.message
      } catch(err) {
        this.SET_PROGRESS_BAR(false)
      } finally {
        this.SET_PROGRESS_BAR(false)
      }
    },
  },
  watch: {
    getSelectedPlantId() {
      this.initialStates()
    }
  }
}
</script>

<style scoped>
.legend-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.container-height {
  height: 70vh;
  overflow-y: auto;
}
</style>